import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "member-modal"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch, nextTick } from 'vue';
import { getVexTableProps } from '@/config';
import { getSalesmanList } from '@/request';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'salesman-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supplierList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'credit'
    },
    defaultSelected: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        var _table$value;

        keyword.value = '';
        supplierId.value = '';
        selectedList.value = props.defaultSelected.map(item => _objectSpread({}, item));
        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    });
    const keyword = ref('');
    const supplierId = ref('');
    const table = ref();
    const tableData = ref([]);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '登录账号',
        field: 'loginName'
      }, {
        title: '联系人',
        field: 'linkMan'
      }, {
        title: '角色名称',
        field: 'employeeName'
      }, {
        title: '团队',
        field: 'supplierName'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              userKeyword: keyword.value,
              type: 1,
              isPage: 1
            };

            if (supplierId.value) {
              params.supplierIds = supplierId.value;
            } else {
              params.supplierIds = props.supplierList.map(v => v.supplier_id).join();
            }

            Axios.get('/admin/creditManage/getSalesmanList', {
              params
            }).then(res => {
              let data = res.data.data;
              tableData.value = data.list;
              resolve({
                total: data.total,
                result: data.list
              });

              if (selectedList.value.length) {
                setTimeout(() => {
                  let selectedRows = data.list.filter(item => selectedList.value.find(v => v.supUserId == item.supUserId));
                  table.value.setCheckboxRow(selectedRows, true);
                }, 300);
              }
            });
          })
        }
      }
    });

    function checkboxVisibleMethod({
      row
    }) {
      if (props.type === 'prize') {
        return true;
      }

      if (props.type === 'credit') {
        return row.isCredited == 0;
      }

      return row.creditRepaymentAudit == 0;
    }

    const selectedList = ref([]);

    function tableSelectHandle(e) {
      let {
        row,
        checked
      } = e;
      console.log(e);
      let findIndex = selectedList.value.findIndex(v => v.supUserId == row.supUserId);

      if (checked && findIndex == -1) {
        selectedList.value.push(row);
      } else {
        selectedList.value.splice(findIndex, 1);
      }
    }

    function tableAllSelectHandle(e) {
      console.log('records');
      let {
        records,
        checked
      } = e;

      if (checked) {
        records.forEach(item => {
          if (selectedList.value.find(v => v.supUserId == item.supUserId)) return;
          selectedList.value.push(item);
        });
      } else {
        tableData.value.forEach(item => {
          let findIndex = selectedList.value.findIndex(v => v.supUserId === item.supUserId);

          if (findIndex > -1) {
            selectedList.value.splice(findIndex, 1);
          }
        });
      }
    }

    function reset() {
      keyword.value = '';
      supplierId.value = '';
      table.value.commitProxy('reload');
    }

    function submit() {
      emit('success', selectedList.value);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "选择业务员",
        width: "70%",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入登录账号/联系人",
          style: {
            "width": "200px",
            "margin-right": "10px"
          }
        }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
          modelValue: supplierId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => supplierId.value = $event),
          placeholder: "请选择团队",
          style: {
            "width": "200px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.supplierList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              value: item.supplier_id,
              label: item.supplier_name,
              key: item.supplier_id
            }, null, 8, ["value", "label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: reset,
          style: {
            "margin": "0"
          }
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]), _unref(visible) ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
          key: 0,
          ref_key: "table",
          ref: table
        }, _unref(tableOptions), {
          "checkbox-config": {
            checkMethod: checkboxVisibleMethod
          },
          onCheckboxChange: tableSelectHandle,
          onCheckboxAll: tableAllSelectHandle
        }), null, 16, ["checkbox-config"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};